import { PlayerContainer, ReactIcons } from "@kalyzee/escaet-ui";
import React from "react";
import MeetingPlayerSoundEffectOverlay from "../MeetingPlayerSoundEffectOverlay";

export type MeetingPlayerHighlightContainerProps = React.PropsWithChildren<{
  fullName?: string;
  groupName?: string;
  isPlayingSound?: boolean;
  isExpert?: boolean;
  isPeda?: boolean;
  soundEffect?: boolean;
  style?: React.CSSProperties;
  isMainMode?: boolean;
  isScreenShare?: boolean;
  isLeader?: boolean;
  extraButtons?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onInfoClick?: React.MouseEventHandler<HTMLDivElement>;
}>;

export const MeetingPlayerHighlightContainer = ({
  fullName,
  groupName,
  isPlayingSound,
  isExpert,
  isPeda,
  soundEffect,
  style,
  isMainMode,
  isScreenShare,
  isLeader,
  extraButtons,
  onClick,
  onInfoClick,
  children,
}: MeetingPlayerHighlightContainerProps) => {
  const soundColor = isExpert
    ? {
        on: "#0090FF",
        off: "#F05E5E",
      }
     : isPeda ? {
        on: "#0090FF",
        off: "#f9af5c",
     } : {
        on: "#0090FF",
        off: isLeader ? "#3bd1c8" : "#444444",
      };

  let backgroundColor: string;
  if (!isMainMode) {
    backgroundColor = isPlayingSound && soundEffect ? soundColor["on"] : soundColor["off"];
  }

  const renderIcon = () => {
    if (isScreenShare && !isMainMode) {
      return (
        <ReactIcons.SharedScreen
          style={{
            color: isLeader ? "white" : "#3BD2C9",
            width: 24,
            height: 24,
          }}
        />
      );
    }
    if (isExpert || isPeda) {
      return (
        <ReactIcons.FilledStar
          style={{
            color: "white",
            fillOpacity: 0.6,
            width: 24,
            height: 24,
          }}
        />
      );
    }
    if (isLeader) {
      return (
        <ReactIcons.FullLeader
          style={{
            color: "white",
            width: 24,
            height: 24,
          }}
        />
      );
    }
    return null;
  };

  const renderName = () => {
    if (isScreenShare && isMainMode) {
      return (
        <div
          style={{
            color: "white",
            fontWeight: 700,
            backgroundColor: "#3BD2C9",
            padding: "0.25em",
            textWrap: "nowrap",
          }}
        >
          Écran partagé par {fullName}
        </div>
      );
    }
    return (
      <div
        style={{
          color: "white",
          fontWeight: 700,
          textWrap: "nowrap",
        }}
      >
        {isPeda ? `${fullName} (Pédagogie)` : fullName}
      </div>
    );
  };

  const renderGroupName = () => {
    if (!groupName) return null;
    return (
      <div
        style={{
          backgroundColor: "#0090FF",
          borderRadius: 2,
          padding: "2px 6px",
          color: "white",
          fontWeight: 800,
          fontSize: 16,
          textWrap: "nowrap",
        }}
      >
        Groupe {groupName}
      </div>
    );
  };

  const renderInfo = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          backgroundColor,
          padding: "0.5em",
          alignItems: "center",
        }}
        onClick={onInfoClick}
      >
        <div style={{
          display: "flex",
          flexDirection: "row",
          gap: "0.5em",
        }}>
          {renderGroupName()}
          {renderIcon()}
          {renderName()}
        </div>
        {extraButtons}
      </div>
    );
  };

  const headerContent = isMainMode;
  const footerContent = !isMainMode;
  return (
    <div onClick={onClick} style={{ backgroundColor: "black", width: "100%", height: "100%", ...(style ?? {}) }}>
      <PlayerContainer.Default
        containerStyle={{
          borderRadius: 2,
          overflow: "hidden",
          width: "100%",
          height: "100%",
        }}
        overlay={isMainMode ? "hover" : "none"}
        headerContent={headerContent ? renderInfo() : undefined}
        footerContent={footerContent ? renderInfo() : undefined}
      >
        {children}
        <MeetingPlayerSoundEffectOverlay enabled={isPlayingSound && soundEffect} color={soundColor["on"]} bottom={!footerContent} />
      </PlayerContainer.Default>
    </div>
  );
};
